export const placeholderPath = `/${
  process.env.NODE_ENV === "production" ? window.GLOBAL.ROUTER_BASE + "/" : ""
}placeholder.svg`;
